import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { TabsService } from './tabs.service';

export interface PeriodicElement {
  position: number;
  name: string;
  email: string;
  brand: string;
  role: string;
  edit: string;
  view: string;

}

export interface CountriesStates {
  position: number;
  countries: string;
  states: string;
}



export interface Group {
  position: number;
  name: string;
  active: string;
}

export interface Role {
  position: number;
  role: string;
}

export interface Region {
  position: number;
  region: string;
}

export interface Programs {
  position: number;
  program: string;
}

export interface Store {
  position: number;
  country: string;
  state: string;
  name: string;
  numberOfUsers: string;
}

const STORE_DATA: Store[] = [
  { position: 1, country: 'Indonesia', state: 'Phillipines', name: 'Store A', numberOfUsers: '100'},
  { position: 2, country: 'Australia', state: 'Darwin', name: 'Store B', numberOfUsers: '150' },
      // { position: 3, country: 'Sasha Christian', state: 'sasha@gmail.com', numberOfUsers: '78' }

];

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Sasha Christian', email: 'sasha@gmail.com',  brand: 'SEED', role: 'user', edit: 'edit', view: 'view'}

];


const REGION_DATA: Region[] = [
  { position: 1, region: 'QueensLand'},
   { position: 1, region: 'Victoria' },
  { position: 1, region: 'Tasmania' }

];


const COUNTRY_DATA: CountriesStates[] = [
  { position: 1, countries: 'Indonesia', states: 'Phillipines, Medan, Mambon'},
  { position: 1, countries: 'Australia', states: 'Darwin, Cairns, Mackay' },
  { position: 1, countries: 'Bulgaria', states: 'Sofia, Varna' },
  { position: 1, countries: 'Botswana', states: 'Ghanzi, Mahalapye, Kanye' },
  // { position: 1, countries: 'Indonesia', states: 'Phillipines, Medan, MAmbon' }

];

const GROUP_DATA: Group[] = [
  { position: 1, name: 'Group 1', active: 'active'},
  { position: 1, name: 'Group 2', active: 'not active' },
  { position: 1, name: 'Group 3', active: 'active' }

];

const ROLE_DATA: Role[] = [
  { position: 1, role: 'User' },
    { position: 2, role: 'Admin' }
]

const PROGRAM_DATA: Programs[] = [
  { position: 1, program: 'CARE Xmas' },
  { position: 2, program: 'MANAGER’S Countdown To Xmas' }
]
@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  displayedColumns: string[] = ['status', 'position', 'name', 'email', 'brand', 'role', 'edit', 'view'];
  displayedCountryColumns: string[] = ['position', 'countries', 'states', 'edit', 'delete'];
  displayedGroupColumns: string[] = ['position', 'name', 'active', 'edit', 'delete'];
  displayedRoleColumns: string[] = ['position', 'role', 'edit', 'delete'];
  displayedRegionColumns: string[] = ['position', 'region', 'edit', 'delete'];
  displayedProgramColumns: string[] = ['position', 'program', 'edit', 'delete'];
  displayedStoreColumns: string[] = ['position', 'country', 'state', 'name', 'numberOfUsers', 'edit', 'delete'];
  dataSource = ELEMENT_DATA;
  countryDataSource = COUNTRY_DATA;
  groupDataSource = GROUP_DATA;
  groupRoleSource = ROLE_DATA;
  regionDataSource = REGION_DATA
 programDataSource = PROGRAM_DATA
  storeDataSource = STORE_DATA
  organisationId: string = '';

  constructor(
	private router: Router,
	private tabsService: TabsService
  ) {
	if (this.router.getCurrentNavigation()?.extras?.state) {
		const routerState = this.router.getCurrentNavigation()?.extras?.state ?? {};

		if (routerState['organisationId']) {
			this.organisationId = routerState['organisationId'];
			this.tabsService.organisationId$.next(this.organisationId);
		}
	} else {
		this.router.navigate(['management']);
	}
  }

  ngOnInit(): void {}
}
